import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { Drawer, SegmentControl } from '@root/shared/ui-kit'

import { orderTypeAtom } from '../../../atoms/trading-orders'

import { OrdersExpandedContentFilter } from './orders-expanded-content-filter'
import { OrdersList } from './orders-list'

import type { LimitOrder } from '@root/entities/limit-order'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type Props = {} & DrawerControlProps

type Tab = LimitOrder.Type | 'all'

export const OrdersDrawer: React.FC<Props> = ({ open, onOpenChange }) => {
  const { t } = useTranslation()
  const [tab, setTab] = useAtom(orderTypeAtom)

  return (
    <Root
      title={t('trading.navigation.limit_orders')}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Content>
        <Header>
          <SegmentControl value={tab} onChange={setTab}>
            <SegmentControl.Item value={'all' satisfies Tab}>
              {t('common.all')}
            </SegmentControl.Item>
            <SegmentControl.Item value={'buy' satisfies Tab}>
              {t('trading.buy')}
            </SegmentControl.Item>
            <SegmentControl.Item value={'sell' satisfies Tab}>
              {t('trading.sell')}
            </SegmentControl.Item>
          </SegmentControl>
        </Header>
        <OrdersExpandedContentFilter />
        <OrdersList />
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)`
  height: var(--max-drawer-height);
`

const Content = styled.div`
  display: grid;

  height: 100vh;
  grid-template-rows: auto auto minmax(0, 1fr);
  gap: 14px;

  overflow: hidden;
`

const Header = styled.div`
  display: grid;
  justify-content: center;
`
